export default function boundaryStatusFlaggedFilter(DataService) {
	"ngInject";

	const filter = function (org) {
		return DataService.isStatusFlagged(org);
	};
	filter.$stateful = true;
	return filter;
}
